let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hEl7z")).then(() => parcelRequire('9ajce'));